import { Sidebar } from 'components/Global';

import { FORMDATA } from 'constants/Data';
import { FC, useEffect, useState } from 'react';
import { checkPermission } from 'utils/utils';
import styles from './index.module.scss';
import { SettingsLayoutProps } from './types';
import { useSelector } from 'react-redux';

// Settings page layout
const SettingsLayout: FC<SettingsLayoutProps> = (props) => {
	const { settingsMenuItems } = FORMDATA;
	const { children, onSideBarChange, selectedSidebar } = props;
	const selectedCompanyPermission = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);


	const [menuItems, setMenuItems] = useState(settingsMenuItems);

	const isUserPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Users',
		permission: ['add', 'view', 'edit', 'delete'],
	});

	const isRolePermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Roles',
		permission: ['add', 'view', 'edit', 'delete'],
	});

	const isCompanyPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Company Setup',
		permission: ['add', 'view', 'edit', 'delete'],
	});
	useEffect(() => {
		let _menuItems = settingsMenuItems;

		if (!isUserPermission) {
			_menuItems = _menuItems.filter((item) => item?.key !== 'users');
		}
		if (!isRolePermission) {
			_menuItems = _menuItems.filter((item) => item?.key !== 'roles');
		}
		if (!isCompanyPermission) {
			_menuItems = _menuItems.filter((item) => item?.key !== 'company');
		}
		

		setMenuItems(_menuItems);
	}, [
		settingsMenuItems,
		isUserPermission,
		isRolePermission,
		isCompanyPermission
	]);

	// JSX
	return (
		<div className={styles['global-layout']}>
			<div className={styles['global-layout__wrapper']}>
				<div className={styles['global-layout__header']}>
					<div className={styles['global-layout__body']}>
						<div className={styles['global-layout__body--sidebar']}>
							<Sidebar
								items={menuItems}
								handleSidebar={onSideBarChange}
								selectedSidebar={selectedSidebar as string}
							/>
						</div>
						<div className={styles['global-layout__body--body']}>
								{children}
							</div>
						</div>
					</div>
				</div>
		</div>
	);
};

export default SettingsLayout;
